<template>
  <div class="layout__item layout__item--aside layout__item--border">
    <div class="h-100">
      <gmap-map
        ref="map"
        :center="{ lat: 47.386145, lng: 8.529222 }"
        :options="mapOptions"
        style="width: 100%; height: 100%"
      >
        <gmap-cluster ref="clusters" :max-zoom="14">
          <map-marker
            v-for="(item, index) in results"
            :key="item.nid"
            :index="index"
            :item="item"
          ></map-marker>
        </gmap-cluster>
        <info-window></info-window>
      </gmap-map>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import mapStyle from './MapStyle'
import MapMarker from './Marker'
import InfoWindow from './InfoWindow'

export default {
  components: {
    MapMarker,
    InfoWindow
  },

  data() {
    return {
      mapOptions: {
        scrollwheel: true,
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: true,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        gestureHandling: 'greedy',
        maxZoom: 16,
        minZoom: 8,
        zoom: 11,
        mapTypeId: 'roadmap',
        styles: mapStyle
      }
    }
  },

  computed: {
    ...mapState('Results', ['results'])
  }
}
</script>
